// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2DYYB","validationTips":"StatementDescriptor_validationTips__2Q5Sk"};